import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import swal from 'sweetalert';
import api from 'services/api';

import { Creators as StoresActions, Types as StoresTypes } from 'store/ducks/stores';

function* getStoreRequest(action) {
  try {
    const { id } = action.payload;
    const url = `store/v2/places/${id}`;
    const response = yield call(api.get, url);

    yield put(StoresActions.getStoreSuccess(response.data));
  } catch (error) {
    yield put(StoresActions.getStoreFailure());
  }
}

function* getStoresRequest(action) {
  try {
    const { page, filter } = action.payload;
    const url = `store/v2/places?page=${page}&per=100&sort=external_store_id&search=${filter}`;
    const response = yield call(api.get, url);

    yield put(StoresActions.getStoresSuccess(response.data));
  } catch (error) {
    yield put(StoresActions.getStoresFailure());
  }
}

function* updateStoreRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `store/v2/places/${id}`;
    yield call(api.put, url, data);

    yield put(push('/points/stores'));
    yield call(swal, 'Atualizado', 'Loja atualizada com sucesso', 'success');
    yield put(StoresActions.updateStoreSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao atualizar', 'Não foi possível atualizar o loja.', 'error');
    yield put(StoresActions.updateStoreFailure());
  }
}

export function* getStoreStatesRequest() {
  try {
    const url = 'user/v2/states?per=27&page=1';
    const response = yield call(api.get, url);
    yield put(StoresActions.getStoreStatesSuccess(response.data));
  } catch (error) {
    yield put(StoresActions.getStoreStatesFailure('Não foi possível carregar os estados'));
  }
}

export default function* sagaStores() {
  yield takeLatest(StoresTypes.GET_REQUEST, getStoreRequest);
  yield takeLatest(StoresTypes.GET_LIST_REQUEST, getStoresRequest);
  yield takeLatest(StoresTypes.UPDATE_REQUEST, updateStoreRequest);
  yield takeLatest(StoresTypes.GET_STATES_REQUEST, getStoreStatesRequest);
}
